import CurrentUser from '../graphql/queries/CurrentUser'
import { useQuery } from '@apollo/client/react'
import { useAppContext, useAppDispatch } from '../AppContext'
import { Actions } from '../AppReducer'
import { useEffect } from 'react'

export default function useCurrentRoom() {
    const { data } = useQuery(CurrentUser)
    const { currentRoom } = useAppContext()
    const dispatch = useAppDispatch()

    const user = data?.user
    const room = user?.rooms?.find(r => r.id === currentRoom)

    useEffect(() => {
        // Only auto-select first room if NO room is currently set
        // Don't override if currentRoom is set but not yet in the list (e.g., joining a new room)
        if (!currentRoom && user?.rooms?.length > 0) {
            dispatch(Actions.setCurrentRoom(user.rooms[0].id))
        }
    }, [currentRoom, user?.rooms, dispatch])

    return room
}
